var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7973 5.11987C10.9708 4.96004 11.2484 4.96004 11.4219 5.11987L11.868 5.56434C11.9525 5.64308 12 5.75026 12 5.86206C12 5.97387 11.9525 6.08104 11.868 6.15978L6.85342 10.8729C6.77246 10.954 6.65943 11 6.54112 11C6.42282 11 6.30978 10.954 6.22882 10.8729L4.13197 8.88536C4.04751 8.80662 4 8.69945 4 8.58764C4 8.47583 4.04751 8.36866 4.13197 8.28992L4.60488 7.84544C4.68584 7.76437 4.79887 7.71837 4.91717 7.71837C5.03548 7.71837 5.14851 7.76437 5.22947 7.84544L6.56789 9.09502L10.7973 5.11987Z",
    fill: "white"
  })));
};
export default SvgCheck;